<template>
  <div class="trade-record">
    <pageHeader title="交易记录" />

    <div class="trade-record-container">
      <div class="page-nav">
        <div class="page-nav-item" @click="currentIndex = 0">
          <span
            :class="['nav-label', currentIndex == 0 ? 'nav-active-label' : '']"
            >我卖出的</span
          >
          <span v-if="currentIndex == 0" class="underline-box"></span>
        </div>
        <div class="page-nav-item" @click="currentIndex = 1">
          <span
            :class="['nav-label', currentIndex == 1 ? 'nav-active-label' : '']"
            >我买到的</span
          >
          <span v-if="currentIndex == 1" class="underline-box"></span>
        </div>
      </div>

      <div class="list-container">
        <accountBug v-if="currentIndex == 1" />
        <accountCell v-if="currentIndex == 0" />
      </div>
    </div>
  </div>
</template>

<script>
import pageHeader from "@/components/PageHeader";
import accountBug from "./components/AccountBug";
import accountCell from "./components/AccountCell";
export default {
  components: {
    pageHeader,
    accountBug,
    accountCell
  },
  data() {
    return {
      currentIndex: 0
    }
  },
  mounted() {
    const { pageTab } = this.$route.query
    if(pageTab) {
      this.currentIndex = pageTab
    }
  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>
.trade-record {
  min-height: 100vh;
  background: #F7F8FA;

  .trade-record-container {
    .page-nav {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 40px;
      background: #ffffff;

      .page-nav-item {
        width: 335px;
        height: 80px;
        line-height: 80px;
        text-align: center;
        position: relative;
        .nav-label {
          display: block;
          position: relative;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 28px;
          color: #333333;
        }
        .nav-active-label {
          font-weight: 600;
          font-size: 36px;
          color: #333333;
          z-index: 2;
        }
        .underline-box {
          position: absolute;
          left: 110px;
          top: 50px;
          width: 116px;
          height: 14px;
          background: linear-gradient(149deg, #ff957f 0%, #ffc8b2 99%);
          border-radius: 7px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/tradeRecord/index.vue